import React from "react";
import { Button, Row } from "react-bootstrap";

const MediaGallery = () => {
  return (
    <>
      <section className="p-5 mx-md-5">
        <h1>Media Gallery</h1>
        <Row className="mt-4"></Row>
      </section>
    </>
  );
};

export default MediaGallery;
